// Code generated by protoc-gen-weave-ts. DO NOT EDIT.
import * as fm from "../../../../fetch.pb.js";
export const SMSNumberBlockService = {
    BlockNumber(fn, req) {
        return fn(`/sms/number-block/v1/block`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    UnblockNumber(fn, req) {
        return fn(`/sms/number-block/v1/unblock`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    IsBlocked(fn, req) {
        return fn(`/sms/number-block/v1/is-blocked?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
};
